import Layout from '@/layout'

export default {
  path: '/picker',
  component: Layout,
  redirect: '/picker/list',
  name: 'picker',
  meta: {
    title: '发货管理',
    role: 1520,
    icon: 'picker'
  },
  children: [
    {
      path: 'choose',
      name: 'picker-choose',
      component: () => import('@/pages/picker/picker-choose'),
      meta: { title: '待提订单', role: 1628 }
    },
    {
      path: 'apply',
      name: 'picker-apply',
      component: () => import('@/pages/picker/picker-apply'),
      hidden: true,
      meta: { title: '提货函', role: 1629 }
    },
    {
      path: 'list',
      name: 'picker-list',
      component: () => import('@/pages/picker/picker'),
      meta: { title: '发货', role: 1520 }
    },
    {
      path: 'change',
      name: 'picker-change',
      component: () => import('@/pages/picker/picker-change'),
      hidden: true,
      meta: { title: '发货单', role: 1521 }
    },
    {
      path: 'notify',
      name: 'picker-notify',
      component: () => import('@/pages/picker/picker-change'),
      hidden: true,
      meta: { title: '通知仓库发货', role: 1521 }
    }
  ]
}
